import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200 pt-14 md:pt-20 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-store-2-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight whitespace-nowrap">
                kakobuyfinds
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              The independent Kakobuy Spreadsheet index and SEO resource center. Helping smart shoppers discover better products faster.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-widest mb-5 whitespace-nowrap">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#categories" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Categories
                </a>
              </li>
              <li>
                <a href="#guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Shopping Guide
                </a>
              </li>
              <li>
                <a href="#articles" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Articles
                </a>
              </li>
              <li>
                <Link to="/blog/complete-kakobuy-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Kakobuy Spreadsheet Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-widest mb-5 whitespace-nowrap">
              Platforms
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Kakobuy
                </a>
              </li>
              <li>
                <span className="text-sm text-background-500 whitespace-nowrap">CSSBuy</span>
              </li>
              <li>
                <span className="text-sm text-background-500 whitespace-nowrap">Superbuy</span>
              </li>
              <li>
                <span className="text-sm text-background-500 whitespace-nowrap">Oopbuy</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-widest mb-5 whitespace-nowrap">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#top" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  Back to Top
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2026 kakobuyfinds.pics — Spreadsheet Authority Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">
              Privacy
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">
              Terms
            </a>
            <a href="#top" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">
              Back to Top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}